import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { HTTP } from '@ionic-native/http/ngx';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  airportApiUrl = 'https://emma.spaziofuturo.eu:5001/sondrio';
  time: string[] = Array();
  timeL: any;
  timeOLD: string[] = Array();
  temperature: any[] = Array();
  humidity: any[] = Array();
  ceiling: any[] = Array();
  precipitation: any[] = Array();
  convective: any[] = Array();
  midCloud: any[] = Array();
  lowCloud: any[] = Array();
  visibility: any[] = Array();
  windSpeed: any[] = Array();
  windDir: any[] = Array();
  windSpeed150m: any[] = Array();
  windDir150m: any[] = Array();
  data: any[] = Array();
  hour: any[] = Array();
  queryArray: object = Object();
  i: any;
  day: any;
  Test: object = Object();
  
  constructor(private http: HttpClient) { }

  httpGET(){
    this.http.get(this.airportApiUrl).subscribe(val => {
    //  this.Test = this.http.get('https://emma.spaziofuturo.eu:4000/forecast_nettuno?', {}, {}).then(val => {
      //console.log(val);
      this.queryArray = val;
      for (let index = 0; index < Object.keys(val).length ; index++) {
        const elementTime = val[index].val1;
        // console.log(elementTime);
        // ------Element Time Formatting-------------
        this.timeL = elementTime.length;
        // console.log(this.timeL);
        if (this.timeL == 11) {
          this.day = elementTime.slice(this.timeL - 11, this.timeL - 10);
        } else {
          this.day = elementTime.slice(this.timeL - 12, this.timeL - 10);
        }
        const month = elementTime.slice(this.timeL - 10, this.timeL - 8);
        const year = elementTime.slice(this.timeL - 8, this.timeL - 4);
        const hour = elementTime.slice(this.timeL - 4, this.timeL - 2);
        const min = elementTime.slice(this.timeL - 2, this.timeL);
        const element = this.day + '/' + month + '/' + year + ' - ' + hour + ':' + min;
        // ------------------------------------------
        const element1 = val[index].val2;
        const element2 = val[index].val8;
        const element3 = val[index].val5;
        const element4 = val[index].val6;
        const element5 = val[index].val7;
        const element6 = val[index].val13;
        const element7 = val[index].val3;
        const element8 = val[index].val4;
        const element9 = val[index].val10;
        const element10 = val[index].val9;
        const element11 = val[index].val12;
        const element12 = val[index].val11;
        this.time.push(element);
        this.temperature.push(element1);
        this.convective.push(element2);
        this.ceiling.push(element3);
        this.lowCloud.push(element4);
        this.midCloud.push(element5);
        this.precipitation.push(element6);
        this.humidity.push(element7);
        this.visibility.push(element8);
        this.windDir.push(element9);
        this.windSpeed.push(element10);
        this.windDir150m.push(element11);
        this.windSpeed150m.push(element12);
      }
    });
    //console.log(this.time);
    /*this.http.get(this.airportApiUrl, {}, {}).then(data => {

      console.log(data.status);
      console.log(data.data); // data received by server
      console.log(data.headers);

    })
    .catch(error => {

      console.log(error.status);
      console.log(error.error); // error message as string
      console.log(error.headers);

    });*/
  }
}
